import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-c006a590")
const _hoisted_1 = { class: "mt-4" }
const _hoisted_2 = {
  key: 0,
  class: "ml-4 text-error text-caption"
}
const _hoisted_3 = ["value", "selected"]
const _hoisted_4 = { class: "mb-5 text-center" }
const _hoisted_5 = ["value", "selected"]
const _hoisted_6 = { class: "v-input__details" }
const _hoisted_7 = { class: "ml-4 text-error text-caption" }
_popScopeId()

import { withDefaults, computed, watch, ref, reactive, onMounted } from 'vue'
import TimeUnit from '@/lib/enums/TimeUnit'
import { IStepData, ITriggerEvent } from '@/interfaces/hoppermation'
import { getEventLabel, readableTimeUnits } from '@/lib/helper'
import { AxiosInstance } from 'axios'
import createHoppermationAPIClient from '@/clients/hoppermation'
import eventBus from '@/lib/eventBus'
import EventNames from '@/lib/enums/eventNames'

interface IProps {
  updateNodeData?: (data: IStepData) => void
  details?: IStepData
}


export default /*#__PURE__*/_defineComponent({
  props: {
    updateNodeData: { type: Function, required: false, default: () => ({}) },
    details: { type: null, required: false, default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { updateNodeData: (data: IStepData) => void, details: IStepData }


const hoppermationApiClient = ref({} as AxiosInstance)
const triggerEvents = ref([] as ITriggerEvent[])
const errorMessage = ref('')
const eventName = ref(props.details.eventName)
let duration = reactive({
  value: props.details.duration?.value || 0,
  unit: props.details.duration?.unit || TimeUnit.MINUTE
})

onMounted(async () => {
  hoppermationApiClient.value = await createHoppermationAPIClient()
  getEvents()
})

const getEvents = async (): Promise<void> => {
  try {
    const res = await hoppermationApiClient.value.get('/trigger-events')
    triggerEvents.value = res.data
  } catch (error) {
    eventBus.$emit(EventNames.SHOW_SNACKBAR, { color: 'error', text: 'snackbar.channels.fetch.error' })
  }
}

const timeUnits = computed((): string[] => {
  return Object.values(TimeUnit)
})

watch(eventName, (value) => {
  if (validate()) {
    eventName.value = value
    prepareData()
    updateParentDetails()
  }
})

watch(duration, (value) => {
  if (validate()) {
    duration = value
    prepareData()
    updateParentDetails()
  }
})

const validate = (): boolean => {
  if (!eventName.value && !duration.value) {
    errorMessage.value = 'details.wait.validation.required'
    return false
  }
  errorMessage.value = ''
  return true
}

const prepareData = (): void => {
  if (!duration.value) {
    duration = { value: 0, unit: TimeUnit.MINUTE }
  }
  if (!eventName.value) {
    eventName.value = ''
  }
}

const updateParentDetails = (): void => {
  props.updateNodeData({ eventName: eventName.value, eventLabel: getEventLabel(triggerEvents.value, eventName.value) })
  props.updateNodeData({ duration })
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_form, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, { class: "row-max" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { class: "pa-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  modelValue: _unref(duration).value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_unref(duration).value = $event)),
                  "persistent-hint": "",
                  label: _ctx.$t('details.wait.duration.value.placeholder'),
                  hint: _ctx.$t('details.wait.duration.value.hint'),
                  class: "mb-0",
                  type: "number"
                }, null, 8, ["modelValue", "label", "hint"]),
                (errorMessage.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(errorMessage.value ? _ctx.$t(errorMessage.value) : ''), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, { class: "row-max" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { class: "px-0" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("select", {
                  class: "px-4 width-full select",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_unref(duration).unit = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(timeUnits), (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item,
                      value: item,
                      selected: item === _unref(duration).unit
                    }, _toDisplayString(_ctx.$t(_unref(readableTimeUnits)(item))), 9, _hoisted_3))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _unref(duration).unit]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('details.wait.desc2')), 1),
        _createVNode(_component_v_row, { class: "row-max" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { class: "pa-0" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("select", {
                  class: "px-4 width-full select",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (eventName.value = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(triggerEvents.value, ({ event, eventLabel }) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: event,
                      value: event,
                      selected: event === eventName.value
                    }, _toDisplayString(eventLabel), 9, _hoisted_5))
                  }), 128))
                ], 512), [
                  [_vModelSelect, eventName.value]
                ]),
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('details.trigger.eventName.hint')), 1),
                _createElementVNode("span", _hoisted_7, _toDisplayString(errorMessage.value ? _ctx.$t(errorMessage.value) : ''), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})